import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { QueryClient } from '@tanstack/react-query'
import { PersistQueryClientProvider } from '@tanstack/react-query-persist-client'
import { createSyncStoragePersister } from '@tanstack/query-sync-storage-persister'
import { AuthProvider } from './auth/AuthContext.tsx'
import { ErrorBoundary } from './components/ErrorBoundary.tsx'
import { App } from './App.tsx'
import { CACHE_KEY } from './lib/constants.ts'
import './index.css'

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      // Al volver a la app conviene refrescar: el saldo puede haber cambiado
      // desde otro móvil mientras esta estaba en segundo plano.
      refetchOnWindowFocus: true,
      retry: 1,
      // Tiene que superar de largo el tiempo entre sesiones, o la caché
      // guardada se descartaría al arrancar y la app abriría en blanco.
      gcTime: 1000 * 60 * 60 * 24,
    },
  },
})

const persister = createSyncStoragePersister({
  storage: window.localStorage,
  key: CACHE_KEY,
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <ErrorBoundary>
      {/* La caché persistida es lo que permite abrir la app sin cobertura y ver
          el saldo de la última vez. Se borra al cerrar sesión: en un móvil
          compartido, el saldo del hermano no puede quedarse ahí. */}
      <PersistQueryClientProvider
        client={queryClient}
        persistOptions={{ persister, maxAge: 1000 * 60 * 60 * 24 }}
      >
        <AuthProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </AuthProvider>
      </PersistQueryClientProvider>
    </ErrorBoundary>
  </StrictMode>,
)
